/**
 * "Reload before starting."
 *
 * Shown in place of the capture entry when the browser is running a bundle that is no longer deployed. Unlike
 * the banner, this one does not let the operator past: workflow configurations are runtime data, so a stale
 * bundle reads today's configuration with old code and can silently omit whatever that configuration expects
 * newer code to do. A missing applicant name is not something to discover from an FBI rejection.
 *
 * There is nothing to lose by reloading here — by definition nothing has been captured yet, which is the whole
 * reason this is the only place a reload is forced.
 */
export function StaleGate() {
  return (
    <div className="panel empty stale-gate">
      <h3>A newer version of EFTCreator is available</h3>
      <p>
        This browser is running an older version of the app. Reload before starting a transaction — capture
        settings are updated centrally, and an out-of-date browser can build an EFT that is missing information.
      </p>
      <p className="field-help">Nothing has been captured yet, so nothing is lost by reloading.</p>
      <button className="btn btn-primary" onClick={() => window.location.reload()}>Reload now</button>
    </div>
  );
}
